import type { DocumentDTO } from '@/services/documents';

/**
 * Receita/documento emitido pelo médico autenticado (consulta própria).
 * Falha fechado: sem doctorId não entra no histórico.
 */
export function isDocumentIssuedByDoctor(
  doc: Pick<DocumentDTO, 'appointment'>,
  doctorUserId: string | null | undefined,
): boolean {
  if (!doctorUserId) return false;
  const appointmentDoctorId =
    doc.appointment?.doctorId || doc.appointment?.doctor?.id || null;
  return appointmentDoctorId === doctorUserId;
}
